import React from 'react'

export default function PolicyText(props) {

    return (

        <div>
            <strong>{props.policy.name}</strong>

            {props.policy.text.split('.').map((text) =>

                <div>{text}. </div>)
            }

        </div>

    );
}
